@if (!loadingService.isReady()) {
  <app-screen-loading (animate.leave)="onLoadingLeave($event)" />
}
<!-- Deferred so the page's own render cost lands after loading rather than competing with it. -->
@if (loadingService.progress().isComplete) {
  <router-outlet></router-outlet>
}

<!-- Must stay after router-outlet: modal dialogs use .show(), not .showModal(),
     so they don't get the top-layer promotion and instead rely on DOM order
     to paint above routed page content. -->
<ng-container [appTeleportOutlet]="'changelog-modal'"></ng-container>

@if (loadingService.isReady()) {
  <app-banner-analytics-consent></app-banner-analytics-consent>
}

<app-tutorial-overlay></app-tutorial-overlay>
